﻿export class ViewDataPreference {
    static prompt = 'prompt';
    static modified = 'modified';
    static original = 'original';
}